module.exports = __webpack_public_path__ + "img/apply.844c9fe9.svg";